import React from "react";
import Upper from "./features/Upper";
import Lower from "./features/Lower";

export default function Company() {
    return <>
        <Upper/>

        <Lower/>
    </>
}